import React from "react";
import { PageHeader } from "@/components/ui-kit";
import { PadPanel, SequencerPanel } from "@/components/MusicTools";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function Studio() {
  return (
    <div>
      <PageHeader eyebrow="Sound & atmosphere" title="Pad & Beat Studio"
        subtitle="Ambient pads, drum loops and percussion — all synthesised live in your browser." />
      <div className="grid lg:grid-cols-2 gap-6 items-start">
        <PadPanel />
        <div>
          <Tabs defaultValue="drums">
            <TabsList className="bg-[#0B101D] border border-white/10 mb-4">
              <TabsTrigger value="drums" data-testid="studio-tab-drums">Drum Machine</TabsTrigger>
              <TabsTrigger value="shaker" data-testid="studio-tab-shaker">Shaker / Percussion</TabsTrigger>
            </TabsList>
            <TabsContent value="drums"><SequencerPanel variant="drums" /></TabsContent>
            <TabsContent value="shaker"><SequencerPanel variant="shaker" initialBpm={100} /></TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
